// 在线时长统计设备数据online_account
import request from '@/utils/request';
export function deviceDurations(data) {
  return request({
    url: '/data/device_online_duration',
    method: 'get',
    params: data
  });
}